import React          from 'react';
import PropTypes      from 'prop-types';
import Flux           from '../../../../flux/Flux';
import VipBadge       from '../../../Dailybonus/SubComponents/VipBadge';
import {OfferAction}  from '../../../Dailybonus/DailybonusActions';
import debounce       from 'lodash.debounce';
import QuantityCircle from './QuantityCircle';
import ReloadHelper   from '../../../../utils/ReloadHelper';
import UrlBuilder     from '../../../../utils/UrlBuilder';

const {offers, signature, offerBgs} = Flux.Constants.DailyBonuses;

class MiddleBlock extends React.Component {

	constructor(props) {
		super(props);

		this.onWallpaperClick = debounce(this.onWallpaperClick.bind(this));
	}

	onWallpaperClick(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.content && this.props.content.mobile) {
			OfferAction.actionDownloadVipWallpapers(this.props.content.mobile);
		}
	}

	onClickHandler(e) {
		ReloadHelper.reload(e.currentTarget.getAttribute('href'), e);
	}

	render() {
		const {offer, vipBadgeShow, content}    = this.props;
		const {conditions, quantity, purchased} = this.props;
		let plate                               = null;
		let link                                = null;
		let backgroundUrl                       = [];
		const addLink                           = content && content.linkVX && (!content.hidden || purchased);
		const isVip                             = Flux.Guest.isVip();

		switch (offer) {
			case offers.VIP:
				if (content && content.mobile) {
					link = content.mobile;
				}
				if (isVip) {
					backgroundUrl.push(content && content.wPreview ? content.wPreview : '/assets/img/placeholder.jpg');
				} else {
					backgroundUrl.push(offerBgs.VIP);
				}
				plate = (
					<div className="dailybonus__mobile--item__middle-block--plate">
						<div className="dailybonus__mobile--item__middle-block--plate__signature">{isVip ? content && content.model.name : signature.OFFER_VIP}</div>
					</div>
				);
				break;
			case offers.VIDEO:
				if (addLink) {
					link = content.linkVX;
				}
				backgroundUrl.push(content && content.preview ? content.preview.url : '/assets/img/placeholder.jpg');
				plate = (
					<div className="dailybonus__mobile--item__middle-block--plate black">
						<div className="dailybonus__mobile--item__middle-block--plate__title">{content ? content.title : ''}</div>
						<div className="dailybonus__mobile--item__middle-block--plate__detail">
							<span className='grey'>({content ? content.duration : ''} min)</span>&nbsp;
							<a className='red'
								onClick={this.onClickHandler}
							    href={UrlBuilder.buildActorProfileUrl(content ? content.model.name : '')}
							>
								{content && content.model.name}
							</a>
						</div>
					</div>
				);
				break;
			case offers.TOP_UP_PERCENT:
			case offers.TOP_UP_FLAT:
				const modelName       = offer === offers.TOP_UP_PERCENT ? signature.TOP_UP_PERCENT : signature.TOP_UP_FLAT;
				const offerBackground = offer === offers.TOP_UP_PERCENT ? offerBgs.TOP_UP_PERCENT : offerBgs.TOP_UP_FLAT;
				backgroundUrl.push(offerBackground);
				plate = (
					<div className="dailybonus__mobile--item__middle-block--plate">
						<div className="dailybonus__mobile--item__middle-block--plate__signature">{modelName}</div>
					</div>
				);
				break;
			case offers.MERCHANDISE:
				backgroundUrl.push(offerBgs.MERCHANDISE);
				break;
			case offers.MESSENGER_GIFT:
				backgroundUrl.push(offerBgs.MESSENGER_GIFT);
				plate = (
					<div className="dailybonus__mobile--item__middle-block--plate">
						<div className="dailybonus__mobile--item__middle-block--plate__signature">{signature.MESSENGER_GIFT}</div>
					</div>
				);
				break;

			case offers.VIDEO_VOUCHER:
				backgroundUrl.push(offerBgs.VIDEO_VOUCHER);
				plate = (
					<div className="dailybonus__mobile--item__middle-block--plate">
						<div className="dailybonus__mobile--item__middle-block--plate__signature">{signature.VIDEO_VOUCHER}</div>
					</div>
				);
				break;
			default:
		}

		return (
			<div style={{backgroundImage: backgroundUrl}} className='dailybonus__mobile--item__middle-block'>
				<VipBadge show={vipBadgeShow} conditions={conditions} />
				{
					offer === offers.VIDEO &&
					<div className="dailybonus__mobile--item__middle-block--play">
						{link ? <a href={link} onClick={this.onClickHandler}><i className='icon -icon-play-rounded-line' /></a> :
							<i className='icon -icon-play-rounded-line' />}
					</div>
				}
				{
					offer === offers.VIP && (
						<div className="dailybonus__mobile--item__middle-block--background img-full"
						     style={{backgroundImage: `url(${backgroundUrl[0]})`}}
						     onClick={this.onWallpaperClick}
						/>
					)
				}
				{
					offer !== offers.VIP && backgroundUrl.map((img, index) => {
						const props = {
							key:       index,
							className: 'dailybonus__mobile--item__middle-block--background ' + (backgroundUrl.length === 1 ? 'img-full' : 'img-grid'),
							style:     {backgroundImage: `url(${img})`},
						};

						return null !== link ? <a href={link} {...props} onClick={this.onClickHandler} /> : <div {...props} />;
					})
				}
				{
					offer === offers.MESSENGER_GIFT &&
					<QuantityCircle quantity={quantity}>
						<img className="dailybonus__mobile--item__middle-block--gift-img"
						     src={content && content.imageUrl}
						     alt={content && content.name}
						/>
					</QuantityCircle>
				}
				{
					offer === offers.VIDEO_VOUCHER &&
					<QuantityCircle quantity={quantity}>
						<i className="icon -icon-voucher-icon dailybonus__mobile--item__middle-block--gift-img" />
					</QuantityCircle>
				}
				{plate}
			</div>
		);
	}

}

MiddleBlock.propTypes = {
	offer:        PropTypes.string,
	conditions:   PropTypes.array,
	effect:       PropTypes.object,
	quantity:     PropTypes.number,
	content:      PropTypes.object,
	vipBadgeShow: PropTypes.bool,
	free:         PropTypes.bool,
	purchased:    PropTypes.bool,
};

export default MiddleBlock;
